export const tickLength = 10;
